import { logError } from '../utilities/logging';
import { fetchRetry } from './fetch';

const SHOPIFY_STORE_DOMAIN = /** @type {any} */ window.shopUrl;

interface removeProps {
  key: string;
}
export const remove = async ({ key }: removeProps) => {
  const response = await fetchRetry({
    url: `${SHOPIFY_STORE_DOMAIN}/cart/change.js`,
    options: {
      method: 'POST',
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    }
  });

  if (!response?.ok) {
    const errorText = (await response?.text()) || 'Failed to remove item from cart';
    logError({
      label: 'remove',
      error: new Error(`Failed to remove item from cart: ${errorText}`),
      message: `Failed to remove item from cart: ${errorText}`,
      extraData: { key }
    });
    throw new Error(`Failed to remove item from cart: ${errorText}`);
  }

  return response.json();
};
